import { HttpClient } from '../../../httpClient'
import { queryString } from '../../../httpClient/queryString'
import { OpalApi } from '../../../schema'

type CreateViewV3 = OpalApi<'CreateViewV3', 201>

export const createView: CreateViewV3 = async (args = {}) => {
  const url = new URL('/loupe/v3/views', window.location.origin)

  url.search = queryString({
    ...args.params?.query,
  })

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
